module.exports = __webpack_public_path__ + "static/media/vinohradnicke_lisy.05783c2a.md";